
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22.342 22.342"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.17 1.183a9.988 9.988 0 109.987 9.989v-.001a9.999 9.999 0 00-9.987-9.988zm0 18.318a8.33 8.33 0 118.329-8.33 8.338 8.338 0 01-8.33 8.33z"}}),_c('path',{attrs:{"d":"M11.17 8.338a1.003 1.003 0 011.002 1.001h1.659A2.655 2.655 0 0012 6.824V5.676h-1.66v1.148A2.654 2.654 0 0011.17 12a1.002 1.002 0 11-1.002 1.002H8.509a2.656 2.656 0 001.831 2.515v.626H12v-.626a2.654 2.654 0 00-.83-5.177 1.002 1.002 0 01-.06-2.003h.06z"}})])
          )
        }
      }
    